import { Likes } from '../../components/Comments/CommentItem';
import { IComment } from '../../types/global/helper';
import { TLikeOrigin } from '../account/types';

export const types = {
    LEAVE_COMMENT: '_LEAVE_COMMENT',
    LEAVE_COMMENT_SUCCESS: '_LEAVE_COMMENT_SUCCESS',
    LEAVE_COMMENT_FAIL: '_LEAVE_COMMENT_FAIL',

    DELETE_COMMENT: '_DELETE_COMMENT',
    DELETE_COMMENT_SUCCESS: '_DELETE_COMMENT_SUCCESS',
    DELETE_COMMENT_FAIL: '_DELETE_COMMENT_FAIL',

    UPDATE_COMMENT: '_UPDATE_COMMENT',
    UPDATE_COMMENT_SUCCESS: '_UPDATE_COMMENT_SUCCESS',
    UPDATE_COMMENT_FAIL: '_UPDATE_COMMENT_FAIL',

    LIKE_COMMENT: '_LIKE_COMMENT',
    LIKE_COMMENT_SUCCESS: '_LIKE_COMMENT_SUCCESS',
    LIKE_COMMENT_FAIL: '_LIKE_COMMENT_FAIL',

    DELETE_COMMENT_LIKE: '_DELETE_COMMENT_LIKE',
    DELETE_COMMENT_LIKE_SUCCESS: '_DELETE_COMMENT_LIKE_SUCCESS',
    DELETE_COMMENT_LIKE_FAIL: '_DELETE_COMMENT_LIKE_FAIL',

    GET_COMMENTS: '_GET_COMMENTS',
    GET_COMMENTS_SUCCESS: '_GET_COMMENTS_SUCCESS',
    GET_COMMENTS_FAIL: '_GET_COMMENTS_FAIL',
};

export interface ICommentsInitialState {
    /** List of all available and public projects */
    selectedComments: IComment[];
    deletingLike?: boolean;
    loading?: boolean;
    liking?: boolean;
    selectedComment?: IComment;
    currentPage?: number;
    limit?: number;
    canLoadMore?: boolean;
    errMsg?: any;
}

export type TCommentCategory = 'project' | 'contest' | 'act' | 'user' | 'thougth';

export interface ILeaveComment {
    /** REQUIRED!! ID of the thougth, project, contest, act or user */
    id: string;
    comment: string;
    /** Use the below to differentiate between comment types  */
    commentType: TCommentCategory;
    isReply?: boolean;
    commentId?: string;
    parentComment?: IComment;
    created_at?: string | Date;
    commentOrigin?: TLikeOrigin;
}

export interface ILeaveCommentResponse {
    comment: IComment;
    isReply?: boolean;
    parentComment?: IComment;
    commentOrigin?: TLikeOrigin;
}

export interface IReactToComment {
    like_category: 'project' | 'movie' | 'review' | 'act' | 'comment';
    like_type: Likes;
    like_origin?: TLikeOrigin;
    commentId: string;
}

export interface ILeaveCommentResponse {
    comment: IComment;
    isReply?: boolean;
    parentComment?: IComment;
    commentOrigin?: TLikeOrigin;
}

export interface IGetComments {
    /** params take the structure as such, ?project=`projectID`&page=`2` */
    id: string;
    params?: string;
    page?: number;
    limit?: number;
    category: 'thougth' | 'project' | 'act';
}

export interface IGetCommentsResponse {
    status: string;
    metadata: {
        total: number;
        totalPages: number;
        page: number;
        limit: number;
    };
    data: IComment[];
}
